import React from "react";
import { Box, Container, Typography } from "@mui/material";

import FormBuilder3 from "../components/FormBuilder3";
import Header from "../components/Header";
import nbev from "../assets/abinbev.json";
import Particle from "../components/Particles";

function AbInBevSurvey() {
  return (
    <Box
      sx={{
        background: "#263859",
      }}
    >
      {/* <Particle /> */}
      <Header />
      <Container maxWidth="md" sx={{ marginTop: "2rem" }}>
        <Typography
          variant="h4"
          sx={{ textAlign: "center", marginBottom: "2rem", color: "#fff" }}
        >
          AB In Bev survey
        </Typography>
        {/* <FormBuilder2 /> */}
        <FormBuilder3 questions={nbev} />
      </Container>
    </Box>
  );
}

export default AbInBevSurvey;
